import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import {Box, Typography} from '@mui/material';
import {gallerySurface} from '../theme/publicTheme';

// Widget de sinteză: culoare plina, numar mare, icon semitransparent.
// Comun panoului (#/admin) si homepage-ului; cine il foloseste da numarul si linkul.
// Fara `to` widgetul arata doar numarul (ex. lucrari/serii pentru vizitatori).
export default function WidgetResursa({label, total, icon: Icon, bg, fg = '#fff', to, subtle = false}) {
    const continut = (
        <Box sx={{
            position: 'relative', bgcolor: subtle ? gallerySurface : bg, color: subtle ? 'text.primary' : fg, borderRadius: 1, overflow: 'hidden',
            boxShadow: subtle ? 'none' : '0 1px 3px rgba(0,0,0,.2)', border: subtle ? 1 : 0, borderColor: 'divider',
            '&:hover .widget-icon': to ? {transform: 'scale(1.1)'} : {},
        }}>
            <Box sx={{p: 1.5, minHeight: 90}}>
                <Typography variant="h4" component="div" sx={{fontWeight: 700}}>{total ?? '…'}</Typography>
                <Typography>{label}</Typography>
            </Box>
            <Icon className="widget-icon" sx={{position: 'absolute', top: 12, right: 12, fontSize: subtle ? 32 : 70, color: subtle ? 'primary.main' : 'inherit', opacity: subtle ? 0.65 : 0.3, transition: 'transform .3s'}} />
            <Box sx={{py: 0.5, textAlign: 'center', bgcolor: subtle ? 'rgba(166,75,56,.07)' : 'rgba(0,0,0,.1)', fontSize: 14}}>
                {to ? 'Vezi toate →' : '\u00a0'}
            </Box>
        </Box>
    );
    const sx = {flex: subtle ? '1 1 160px' : '1 1 220px', display: 'block', color: 'inherit', textDecoration: 'none', '&:hover': {textDecoration: 'none', color: 'inherit'}};
    return to
        ? <Box component={RouterLink} to={to} sx={sx}>{continut}</Box>
        : <Box sx={sx}>{continut}</Box>;
}
